import React from "react";
import { Stack, TextField } from "@mui/material";
import {
  defaultCountries,
  usePhoneInput,
} from "react-international-phone";
import MuiFlagSelect from "./MuiFlagSelect";

const MyPhoneInput = ({ value, onChange, t }) => {
  const {
    inputValue,
    handlePhoneValueChange,
    inputRef,
    country,
    setCountry,
  } = usePhoneInput({
    defaultCountry: "ca",
    value,
    countries: defaultCountries,
    onChange: (data) => onChange(data.phone),
  });

  return (
    // <Box 
    // display="flex" 
    // // alignItems="center" 
    // sx={{alignItems: 'center'}}
    // gap={1}>
    <Stack direction={'row'} spacing={0}
      sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Flag selector */}
      <MuiFlagSelect
        selectedIso2={country}
        onSelect={(c) => setCountry(c.iso2)}
      />

      {/* Phone input */}
      <TextField
        inputRef={inputRef}
        value={inputValue}
        onChange={handlePhoneValueChange}
        placeholder={t("phone")}
        fullWidth
        size="small"
        sx={{
          "& .MuiOutlinedInput-root": {
            // borderRadius: "2px",
            "& fieldset": {
              border: "none", // ✅ remove border
            },
          },
          "& input": {
            fontSize: "14px",
          },
          "& .MuiOutlinedInput-input": {
            paddingLeft: 0, // ✅ remove right padding
          },
        }}
      />
   </Stack>
  );
};

export default MyPhoneInput;